import WsProvider from './provider/WSProvider'

var base64 = require('base64_js');
var serviceName = "seo";
var seoService = {
    linkKontrol(link) {
        var userDataExon = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataExon"))));
        var param = {
            data: {
                yonetimId: userDataExon["yonetimId"],
                userToken: userDataExon["token"],
                firmaKodu: userDataExon["firmaKodu"],
                link: link,
                methodName: "linkKontrol"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    seoTanimlama(tipi,link,seobaslik,seoIcerik,kategori) {
        var userDataExon = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataExon"))));
        var param = {
            data: {
                yonetimId: userDataExon["yonetimId"],
                userToken: userDataExon["token"],
                firmaKodu: userDataExon["firmaKodu"],
                tipi: tipi,
                link: link,
                seobaslik: seobaslik,
                seoIcerik: seoIcerik,
                kategori: kategori,
                methodName: "linkKontrol"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
}

export default seoService

